import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Link = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.14642 2.14647C9.72239 0.570495 12.2776 0.570493 13.8535 2.14647C15.4295 3.72244 15.4295 6.27761 13.8535 7.85358L12.7071 9.00002C12.5118 9.19528 12.1952 9.19528 12 9.00002C11.8047 8.80476 11.8047 8.48818 12 8.29291L13.1464 7.14647C14.3319 5.96102 14.3319 4.03903 13.1464 2.85357C11.961 1.66812 10.039 1.66813 8.85353 2.85357L7.13131 4.57579C5.79245 5.91465 5.79245 8.08538 7.13131 9.42424C7.21295 9.50588 7.29861 9.58107 7.38765 9.6498C7.65354 9.85504 7.73588 10.2641 7.49836 10.5016C7.35062 10.6494 7.1212 10.6844 6.94866 10.5666C6.7639 10.4404 6.58818 10.2953 6.4242 10.1313C4.69481 8.40196 4.69482 5.59807 6.42421 3.86868L8.14642 2.14647ZM3.29287 7C3.48813 6.80474 3.80472 6.80474 3.99998 7.00001C4.19524 7.19527 4.19524 7.51185 3.99998 7.70711L2.85354 8.85355C1.66808 10.039 1.66809 11.961 2.85355 13.1465C4.03901 14.3319 5.961 14.3319 7.14645 13.1465L9.14643 11.1465C10.3319 9.96101 10.3319 8.03902 9.14642 6.85357C8.9777 6.68485 8.79406 6.54015 8.59975 6.41945C8.30217 6.23462 8.19753 5.80247 8.44524 5.55476C8.58246 5.41754 8.79178 5.37762 8.96135 5.472C9.28115 5.65 9.58188 5.87482 9.85353 6.14646C11.4295 7.72244 11.4295 10.2776 9.85354 11.8536L7.85356 13.8536C6.27759 15.4295 3.72243 15.4295 2.14644 13.8536C0.570454 12.2776 0.570449 9.72243 2.14643 8.14645L3.29287 7Z"
      />
    </svg>
  )
})

export default Link
